import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Sidebar from './SidebarConsultant';
import { CONSULTANT_PROJECT_ROUTES } from 'pages/consultant/projects/constants';

class Layout extends Component {
  static displayName = Layout.name;

  render() {
    const { location } = this.props;
    const pathname = location && location.pathname;
    const isConsultantHome = pathname === '/Consultant/MainMenu';
    const hideSidebar =
      pathname === '/Consultant/TextDetails' ||
      (pathname && pathname.startsWith('/Consultant/TextDetails/')) ||
      pathname === '/Consultant/CreateTraductionIA' ||
      pathname === CONSULTANT_PROJECT_ROUTES.CREATE_IA_SMART_TEXT ||
      (pathname && pathname.startsWith(`${CONSULTANT_PROJECT_ROUTES.CREATE_IA_SMART_TEXT}/`));
    const shellClassName = isConsultantHome
      ? 'app-shell app-shell--writer-home'
      : 'app-shell';
    return (
      <div style={{ backgroundColor: isConsultantHome ? '#F6F6F6' : 'transparent', minHeight: '100vh', width: '100%', margin: 0, padding: 0 }}>
        <div className={shellClassName} style={{ backgroundColor: isConsultantHome ? '#F6F6F6' : 'transparent', width: '100%', minHeight: '100vh' }}>
          {!hideSidebar && <Sidebar />}
          <div className="wrapper-content" style={{ backgroundColor: isConsultantHome ? '#F6F6F6' : 'transparent' }}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Layout);
